import environmentNames from './environmentNames';
import { Environment } from './environment';

const messages = {
    confirmationEmailWasSent: "We've sent you a confirmation email. Check your inbox",
    scriptAlreadyExists: 'Script with this name already exists',
    conversationAlreadyExists: 'Conversation with this name already exists',
    projectAlreadyExists: 'Project with this name already exists',
    commentAlreadyExists: 'Comment with this name already exist',
    tagAlreadyExists: 'Version with this name already exists. Please choose another name',
    tagIsEmpty: 'Enter tag name',
    userNameNotAllowedSymbols: 'Can contain only alphabetical characters or dash.(a-z, -)',
    alanTutorNotAdaptedForMobile: 'Alan AI Studio was created for desktop browsers. Use Alan AI Studio within a desktop browser for a better experience',
    incorrectProjectOptions: 'Incorrect options were saved to project previously. Please contact support to fix it',
    incorrectJSONInProjectOptions: 'Please enter a valid JSON',
    alanBtnOptionsWereSaved: 'Alan Button options were applied',
    alanBtnWasEnabled: 'Alan Button is enabled',
    alanBtnWasDisabled: 'Alan Button is disabled',
    cannotDeleteCurrentVersionFromProd: 'You cannot delete version which is running on production. Please switch to another one first',
    lastVersionIsOnProd: `Keeping "Last Version" running on ${environmentNames[Environment.Production]} is not recommended because this version could contain all of the latest changes in your project`,
    featureNotAvailable: 'This feature isn\'t available on your plan.',
    customWakeWordFeatureNotAvailable: 'Custom wake word feature isn\'t available on your plan.',
    scriptTooLarge: 'This script is too large to open. Displaying the script fragment.',
    projectIsSyncedWithGithub: 'Your project is up to date with the repository.',
    pullFromGithubIsNotNeeded: 'Your project is already up to date with the repository. Pull is not needed.',
    projectIsNotSyncedWithGithub: 'Your project probably is different with the repository. Pull is needed.',
    pushToGithubIsNotNeeded: 'Your project is already up to date with the repository. Push is not needed.',
    branchNotFound: 'Branch that you synced with not found, please reset github integration and add your repo again.',
    wakeWordPathContainsInvalidUrl: 'The wake word path is invalid. Please provide a valid URL.',
    wakeWordPathHasInvalidFormat: 'The format of the wake word path is invalid. It must start with https://storage.googleapis.com/ and end with “rar/zip/tar/tar.gz”.',
    organizationNameNotAllowedSymbols: 'Can contain only only ASCII alphanumeric characters and "-.:())"',
    scriptGeneratorErr: 'An error occurred during script generation. Please try again later',
};

export default messages;
